<template>
  <div>
    <div v-if="!pageLoading">
      <back-nav to="PersonalDetails" />
      <top-card current="VehicleDetails" :cover="coverType.covertypeId" :amount="coverType.riskPremDto.totalPremium">Kindly provide some additional details before you proceed</top-card>
      <v-card flat class="tw-mt-5 md:tw-mt-16">
        <div class="tw-px-4 md:tw-px-8">
          <card-title icon="mdi-car">Vehicle Details</card-title>
        </div>
        <div class="tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">
          <v-form v-model="isValid">
            <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-2">
              <v-text-field
                  id="car-make"
                  v-model="car.make"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Vehicle Make"
                  type="text"
                  disabled
                  :rules="[required('Vehicle Make')]"
              ></v-text-field>
              <v-text-field
                  id="car-model"
                  v-model="car.model"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Vehicle Model"
                  type="text"
                  :rules="[required('Vehicle Model')]"
                  disabled
              ></v-text-field>
              <v-text-field
                  id="car-value"
                  v-if="coverType.covertypeId === 101"
                  v-model="car.valueOfCar"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Value of Vehicle (Kshs.)"
                  type="text"
                  disabled
              ></v-text-field>
              <v-text-field
                  id="car-age"
                  v-model="car.yearOfManufacture"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Year Of Manufacture"
                  type="number"
                  disabled
              ></v-text-field>
              <v-text-field
                  id="car-reg"
                  v-model="car.registrationNumber"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Registration Number"
                  type="text"
                  :rules="[required('Registration Number')]"
              ></v-text-field>
              <v-text-field
                  id="car-engine"
                  v-model="car.engineNumber"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Engine No."
                  :rules="[required('Engine No.')]"
                  type="text"
              ></v-text-field>
              <v-text-field
                  v-model="car.logBookNumber"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Logbook No. (optional)"
                  type="text"
              ></v-text-field>
              <v-text-field
                  v-model="car.cc"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Engine Size (CC)"
                  type="number"
                  :rules="[required('Engine Size (CC)')]"
              ></v-text-field>
              <v-text-field
                  v-model="car.color"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Colour"
                  type="text"
                  :rules="[required('Color')]"
              ></v-text-field>
              <v-text-field
                  v-model="car.seatingCapacity"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Seating Capacity"
                  type="number"
                  required
                  :rules="[min('Seating Capacity',1), max('Seating Capacity', 9)]"
              ></v-text-field>
              <v-text-field
                  v-model="car.chassisNumber"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Chassis No."
                  type="text"
                  :rules="[required('Chassis No.'),minLength('Chassis No.', 10)]"
              ></v-text-field>

              <express-upload :uid="getQoute.client.kraPinNumber" :phoneNumber="authenticatedUser.phone_number" :fullName="authenticatedUser.name" :email="authenticatedUser.email" name="Log Book" />

            </div>

            <schedule-inspection v-if="coverType.covertypeId === 101" v-model="check" :scheduled="scheduled" :quote-id="parseInt(quote, 10)" :rules="[v => !!v || 'Inspection choice is required']" />

            <documents-upload v-if="!hideImage" v-model="documents" :all-documents="getQoute.document" registration-number="COVER" />

            <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 md:tw-mt-8 tw-pb-8">
              <v-btn block large
                     id="proceed"
                     color="secondary"
                     class="my-3 "
                     :loading="loading"
                     :disabled="!isValid"
                     @click="proceed">
                {{ isValid ? 'Continue' : 'Check if all fields are filled' }}
              </v-btn>
            </v-card-actions>

          </v-form>
        </div>
      </v-card>
    </div>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import CardTitle from '@/components/shared/CardTitle';
import TopCard from '@/components/buy/TopCard';
import ScheduleInspection from '@/components/buy/ScheduleInspection';
import BackNav from '@/components/buy/BackNav';
import { mapGetters } from 'vuex';
import validations from '@/utils/validations';
import axios from 'axios';
import { changeFormat } from '@/utils/time';
import DocumentsUpload from '@/components/buy/DocumentsUpload';
import { FB_BUY_VEHICLE } from '@/utils/const';
import ExpressUpload from '@/components/shared/ExpressUpload';

export default {
  name: 'VehicleDetails',
  components: {
    ExpressUpload,
    DocumentsUpload,
    BackNav,
    ScheduleInspection,
    TopCard,
    CardTitle,
  },
  data() {
    return {
      loading: false,
      car: {},
      benefit: '',
      quote: '',
      pageLoading: true,
      ...validations,
      isValid: false,
      check: null,
      scheduled: false,
      documents: [],
      hideImage: true,
    };
  },
  computed: {
    ...mapGetters('rfq', ['getQoute']),
    ...mapGetters('auth', ['authenticatedUser']),
    coverType() {
      return this.getQoute !== {} ? this.getQoute.covertypes.find((e) => e.riskId === this.benefit) || this.getQoute.covertypes.find((e) => e.selected === 'Y') : {};
    },
  },
  mounted() {
    const quote = this.$route.query.q;
    this.quote = quote;
    this.benefit = parseInt(this.$route.query.b, 10);
    this.$store.dispatch('rfq/getQuotation', quote).then(() => {
      this.car = {
        cc: this.coverType.car.cc || '',
        chassisNumber: this.coverType.car.chassisNumber || '',
        color: this.coverType.car.color || '',
        engineNumber: this.coverType.car.engineNumber || '',
        entertainmentSysValue: this.coverType.car.entertainmentSysValue || '',
        hasInsurance: this.coverType.car.hasInsurance || '',
        logBookImageUrl: this.coverType.car.logBookImageUrl || '',
        logBookNumber: this.coverType.car.logBookNumber || '',
        make: this.coverType.car.make || '',
        model: this.coverType.car.model || '',
        registrationNumber: this.coverType.car.registrationNumber || '',
        seatingCapacity: parseInt(this.coverType.car.seatingCapacity, 10) || null,
        valueOfCar: this.coverType.car.valueOfCar || '',
        variant: this.coverType.car.variant || '',
        windscreenValue: this.coverType.car.windscreenValue || '',
        yearOfManufacture: this.coverType.car.yearOfManufacture || '',
      };
      if ('vehicleEvaluation' in this.getQoute) this.scheduled = true;
      this.pageLoading = false;
    });
    // eslint-disable-next-line no-unused-vars
    this.$root.$on('inspection-scheduled', (_data) => {
      this.hideImage = true;
    });
  },
  methods: {
    proceed() {
      this.loading = true;
      const data = {
        addressLine1: '1245',
        bankAccount: this.getQoute.client.bankAccount,
        bankBranch: this.getQoute.client.bankBranch,
        bankName: this.getQoute.client.bankName,
        coverFrom: this.changeFormat(this.getQoute.coverFrom),
        documents: this.documents,
        email: this.getQoute.client.email,
        fullName: this.getQoute.client.fullName,
        idNumber: this.getQoute.client.idNumber,
        kraPinNumber: this.getQoute.client.kraPinNumber,
        mobileNumber: this.getQoute.client.mobileNumber,
        pinNumber: this.getQoute.client.kraPinNumber,
        poBoxNo: this.getQoute.client.poBoxNo,
        postalCode: this.getQoute.client.postalCode,
        gender: this.getQoute.client.gender,
        carDTOS: [this.car],
        prodId: this.coverType.productCode,
        quoteId: parseInt(this.quote, 10),
        selectedRiskId: parseInt(this.benefit, 10),
        stepCode: 'CONFIRM_POLICY',
        agentId: window.localStorage.getItem('agentId'),
      };

      const date = new Date(this.getQoute.coverFrom);
      const newDate = new Date(date.setFullYear(date.getFullYear() + 1));
      const day = newDate.getDate();
      const month = newDate.getMonth();
      const year = newDate.getFullYear();
      const doubleInsuranceData = {
        policyStartDate: this.changeFormat(this.getQoute.coverFrom),
        // eslint-disable-next-line prefer-template
        policyEndDate: day + '/' + month + '/' + year,
        vehicleRegistrationNumber: this.car.registrationNumber,
        chassisNumber: this.car.chassisNumber,
      };

      axios.post('/customer/gis/policies/double-insurance', doubleInsuranceData)
        .then((response) => {
          if (response.data.result === 'Vehicle is not insured' || response.data.message === 'No Records Found') {
            axios.put('/customer/quotation/update', data)
            // eslint-disable-next-line no-unused-vars
              .then((response2) => {
                this.loading = false;
                this.$toast.success('Vehicle Details successfully saved', 'Vehicle Details');
                this.$analytics.logEvent(FB_BUY_VEHICLE);
                this.$emit('to-cover-summary');
              });
          } else {
            this.loading = false;
            this.$toast.error(response.data.message);
          }
        });
    },
    changeFormat,
  },
};
</script>
